import { useRef, useCallback, useEffect } from 'react';
import { fabric } from 'fabric';
import { MODESTATE } from '@view/page_v3/AiEdit/CONST'


export function useDrawRect(fabricInstanceRef, drawingRef, getIsDraw, modeStateRef) {
    const rectRef = useRef(null);

    const startRect = useCallback((event) => {
        const canvas = fabricInstanceRef.current;
        if (!canvas || !drawingRef.current) return;

        const activeObject = canvas.getActiveObject();
        if (activeObject) return;

        const { offsetX, offsetY } = event.e;
        const zoom = canvas.getZoom();
        const canvasOffsetX = canvas.viewportTransform[4];
        const canvasOffsetY = canvas.viewportTransform[5];
        const x = (offsetX - canvasOffsetX) / zoom;
        const y = (offsetY - canvasOffsetY) / zoom;

        const rect = new fabric.Rect({
            left: x,
            top: y,
            width: 0,
            height: 0,
            fill: modeStateRef.current == MODESTATE.ERASER ? ' ': 'rgba(30, 144, 255, 0.8)',
            strokeWidth: 2,
            lockRotation: true,
            cornerSize: 8,
            selectable: false,
            evented: false,
            globalCompositeOperation: modeStateRef.current == MODESTATE.ERASER? 'destination-out' : 'source-over'
        });

        rect.setControlsVisibility({ mtr: false });

        rect.startX = x;
        rect.startY = y;

        canvas.add(rect);
        rectRef.current = rect;
    }, [fabricInstanceRef, drawingRef]);

    const moveRect = useCallback((event) => {
        const canvas = fabricInstanceRef.current;
        const rect = rectRef.current;
        if (!canvas || !rect || !drawingRef.current) return;

        const { offsetX, offsetY } = event.e;
        const zoom = canvas.getZoom();
        const canvasOffsetX = canvas.viewportTransform[4];
        const canvasOffsetY = canvas.viewportTransform[5];
        const x = (offsetX - canvasOffsetX) / zoom;
        const y = (offsetY - canvasOffsetY) / zoom;

        const width = Math.abs(x - rect.startX);
        const height = Math.abs(y - rect.startY);

        rect.set({
            left: x < rect.startX ? x : rect.startX,
            top: y < rect.startY ? y : rect.startY,
            width: width,
            height: height,
        });

        canvas.renderAll();
    }, [fabricInstanceRef, drawingRef]);

    const endRect = useCallback(() => {
        const canvas = fabricInstanceRef.current;
        if (!canvas || !rectRef.current) return;

        rectRef.current.setCoords();
        rectRef.current = null;

        const rectList = canvas.getObjects().filter(obj => obj.type === 'rect');
        if (typeof getIsDraw === 'function') {
            getIsDraw(rectList);
        }
    }, [fabricInstanceRef, getIsDraw]);

    const handleMouseOut = () => {
        if (drawingRef.current) {
            endRect();
        }
    };

    useEffect(() => {
        window.addEventListener('mouseout', handleMouseOut);
        return () => {
            window.removeEventListener('mouseout', handleMouseOut);
        };
    }, []);

    return {
        startRect,
        moveRect,
        endRect,
    };
}
